
// consent.service.ts
import { Injectable } from '@angular/core';
import { setRootCookie, getCookie, deleteRootCookie } from '../utils/cookie-utils';

export type ConsentVal = 'allow' | 'deny';
export interface ComplianzConsent {
  functional: 'allow';
  preferences: ConsentVal | null;
  statistics:  ConsentVal | null;
  marketing:   ConsentVal | null;
  policyId?:   string | null;
  savedCategories?: string[];
}

@Injectable({ providedIn: 'root' })
export class ConsentService {

  read(): ComplianzConsent {
    const savedCategoriesCookie = getCookie('cmplz_saved_categories');
    let savedCategories: string[] = ['functional'];
    
    if (savedCategoriesCookie) {
      try {
        const parsed = JSON.parse(savedCategoriesCookie);
        if (Array.isArray(parsed)) {
          savedCategories = parsed;
        }
      } catch (e) {
        // Se falhar, mantém o array padrão
      }
    }
    
    return {
      functional: 'allow',
      preferences: getCookie('cmplz_preferences'),
      statistics:  getCookie('cmplz_statistics'),
      marketing:   getCookie('cmplz_marketing'),
      policyId:    getCookie('cmplz_policy_id'),
      savedCategories
    } as ComplianzConsent;
  }

  hasAnyChoice(): boolean {
    const savedCategoriesCookie = getCookie('cmplz_saved_categories');
    console.log('hasAnyChoice - hostname:', window.location.hostname);
    console.log('hasAnyChoice - cmplz_saved_categories:', savedCategoriesCookie);
    console.log('hasAnyChoice - all cookies:', document.cookie);
    
    if (!savedCategoriesCookie) {
      return false;
    }
    
    try {
      const savedCategories = JSON.parse(savedCategoriesCookie);
      const hasElements = Array.isArray(savedCategories) && savedCategories.length > 0;
      console.log('hasAnyChoice - parsed:', savedCategories, 'hasElements:', hasElements);
      return hasElements;
    } catch (e) {
      console.log('hasAnyChoice - parse error:', e);
      return false;
    }
  }

  /** Grava o consentimento "à la Complianz" no domínio raiz */
  save(opts: {
    preferences?: ConsentVal | null;
    statistics?:  ConsentVal | null;
    marketing?:   ConsentVal | null;
    policyId?:    string | null;
  }) {
    // Sempre cria/atualiza o cookie functional como 'allow'
    setRootCookie('cmplz_functional', 'allow');
    
    // Cria/atualiza os cookies de consentimento (se fornecidos)
    if (opts.preferences !== undefined && opts.preferences !== null) {
      setRootCookie('cmplz_preferences', opts.preferences);
    }
    if (opts.statistics !== undefined && opts.statistics !== null) {
      setRootCookie('cmplz_statistics', opts.statistics);
    }
    if (opts.marketing !== undefined && opts.marketing !== null) {
      setRootCookie('cmplz_marketing', opts.marketing);
    }
    if (opts.policyId !== undefined && opts.policyId !== null) {
      setRootCookie('cmplz_policy_id', opts.policyId);
    }
    
    // Cria o cookie cmplz_saved_categories como array JSON
    const savedCategories = ['functional']; // sempre inclui functional
    
    if (opts.preferences === 'allow') savedCategories.push('preferences');
    if (opts.statistics === 'allow') savedCategories.push('statistics');
    if (opts.marketing === 'allow') savedCategories.push('marketing');
    
    setRootCookie('cmplz_saved_categories', JSON.stringify(savedCategories));
  }

  /** Reset total (para re‑apresentar banner) */
  resetAll() {
    ['cmplz_functional','cmplz_preferences','cmplz_statistics','cmplz_marketing','cmplz_policy_id','cmplz_saved_categories']
      .forEach(deleteRootCookie);
  }
}
